import axios from "axios";

const instance = axios.create({
  baseURL: "https://api.coingecko.com/api/v3/",
  params: { vs_currency: "usd" },
});

export default instance;
